import { atcb_action as Atcb } from 'add-to-calendar-button';
import momentTZ from 'moment-timezone';
import 'add-to-calendar-button/assets/css/atcb.css';

const addToCalendar = ({ user, job, isDoubleBlinded }) => {
  const meetingAt = momentTZ.tz(job.meetingAt, user.timeZone);
  const separator = '-'.repeat(20);
  const expertInfo = isDoubleBlinded ? `${job.expert.fullName}` : `${job.expert.fullName}, ${job.expert.title} at ${job.expert.organization.name}`;
  const icsContent = {
    name: `${job.project.title} - ${job.expert.fullName}`,
    description: `Expert Info: ${expertInfo}\nProject Info: ${job.project.title}\n${job.project.preInterviewLink ? `\nPre-interview material is available at ${job.project.preInterviewLink}` : ''}${job.qualificationResponses ? `\n\n${job.qualificationResponses.map((el, index) => `${index + 1}. ${el.question}: ${el.response.map((res) => `\n-${res}`)}`).join('\n\n')}` : ''}\n${separator}\n\n${job.zoomMeeting.meetingInvite}`,
    organizer: 'Dexter|help@dexterexperts.com',
    startDate: meetingAt.format('YYYY-MM-DD'),
    startTime: meetingAt.format('HH:mm'),
    endTime: meetingAt.add(1, 'hour').format('HH:mm'),
    timeZone: user.timeZone,
    location: job.zoomMeeting.meetingLink,
    options: ['Apple', 'Google', 'iCal', 'Microsoft365', 'Outlook.com', 'Yahoo'],
    duration: '1H',
    trigger: 'click',
    iCalFileName: `Dexter-${job.expert.fullName}`,
  };

  return Atcb(icsContent);
};
export default addToCalendar;
